export const CLIENT_ACCESS_TYPE = 'Client';
